import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Auth } from 'store/auth/actions';
import { Button } from 'components/Button/Button';
import { successToast } from 'configuration/notifications';
import { Checkbox } from '@atlaskit/checkbox';

const ModalUserOptionForm = ({ userOption, onClose }) => {
  const dispatch = useDispatch();

  const [reservePhoneNumber, setReservePhoneNumber] = useState(userOption.reserve_phone_number);
  const [reserveFio, setReserveFio] = useState(userOption.reserve_fio);
  const [reserveCommentary, setReserveCommentary] = useState(userOption.reserve_commentary);
  const [reserveInstruments, setReserveInstruments] = useState(userOption.reserve_instruments);
  const [reserveDate, setReserveDate] = useState(userOption.reserve_date);

  const [rentPhoneNumber, setRentPhoneNumber] = useState(userOption.rent_phone_number);
  const [rentFio, setRentFio] = useState(userOption.rent_fio);
  const [rentCommentary, setRentCommentary] = useState(userOption.rent_commentary);
  const [rentInstruments, setRentInstruments] = useState(userOption.rent_instruments);
  const [rentDate, setRentDate] = useState(userOption.rent_date);

  const handleSave = () => {
    dispatch(
      Auth.setUserOption({
        rent_phone_number: rentPhoneNumber,
        rent_fio: rentFio,
        rent_commentary: rentCommentary,
        rent_instruments: rentInstruments,
        rent_date: rentDate,
        reserve_phone_number: reservePhoneNumber,
        reserve_fio: reserveFio,
        reserve_commentary: reserveCommentary,
        reserve_instruments: reserveInstruments,
        reserve_date: reserveDate,
      })
    );
    successToast('Настройки успешно сохранены');
    onClose();
  };

  return (
    <>
      <div className="user-option-content">
        <div className="checkbox-list">
          <div className="user-option-subheader">Резервы</div>
          <Checkbox
            label="Номер телефона"
            isChecked={reservePhoneNumber}
            onChange={() => {
              setReservePhoneNumber(!reservePhoneNumber);
            }}
          />
          <Checkbox
            label="ФИО"
            isChecked={reserveFio}
            onChange={() => {
              setReserveFio(!reserveFio);
            }}
          />
          <Checkbox
            value="Комментарий"
            label="Комментарий"
            isChecked={reserveCommentary}
            onChange={() => {
              setReserveCommentary(!reserveCommentary);
            }}
          />
          <Checkbox
            label="Инструмент"
            isChecked={reserveInstruments}
            onChange={() => {
              setReserveInstruments(!reserveInstruments);
            }}
          />
          <Checkbox
            label="Дата до"
            isChecked={reserveDate}
            onChange={() => {
              setReserveDate(!reserveDate);
            }}
          />
        </div>
        <div className="checkbox-list">
          <div className="user-option-subheader">Аренды</div>
          <Checkbox
            label="Номер телефона"
            isChecked={rentPhoneNumber}
            onChange={() => {
              setRentPhoneNumber(!rentPhoneNumber);
            }}
          />
          <Checkbox
            label="ФИО"
            isChecked={rentFio}
            onChange={() => {
              setRentFio(!rentFio);
            }}
          />
          <Checkbox
            label="Комментарий"
            isChecked={rentCommentary}
            onChange={() => {
              setRentCommentary(!rentCommentary);
            }}
          />
          <Checkbox
            label="Инструмент"
            isChecked={rentInstruments}
            onChange={() => {
              setRentInstruments(!rentInstruments);
            }}
          />
          <Checkbox
            label="Дата до"
            isChecked={rentDate}
            onChange={() => {
              setRentDate(!rentDate);
            }}
          />
        </div>
      </div>
      <Button className="user-option-btn" onClick={handleSave}>
        Сохранить
      </Button>
    </>
  );
};

ModalUserOptionForm.propTypes = {
  userOption: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export { ModalUserOptionForm };
